import React from 'react';
import { styled } from '@mui/material/styles';
import { Typography, Button } from '@mui/material';
import Paper, { PaperProps } from '@mui/material/Paper';
import './Comparison.css';
import comparisonImg from '../../assets/img/satvsact/SAT-ACT_compare.png';

const ComparisonPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  margin: '2vh 0',
  background: '#fff',
  color: '#001D73',
  minHeight: '100vh',
  maxWidth: '100%',
  position: 'relative',
  boxShadow: 'none',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  padding: '3vmax 0 2vmax 0',
}));

const AnimatedCTA = styled(Button)(({ theme }) => ({
  background: '#0146C7',
  color: '#fff',
  fontFamily: 'PoppinsSemiBold',
  fontSize: '1.2vmax',
  marginTop: '2vmax',
  padding: '1vmax 2vmax',
  borderRadius: '2vmax',
  boxShadow: '0 4px 20px rgba(1,70,199,0.15)',
  transition: 'transform 0.2s, box-shadow 0.2s',
  animation: 'ctaPulse 1.5s infinite alternate',
  '@keyframes ctaPulse': {
    from: { transform: 'scale(1)' },
    to: { transform: 'scale(1.07)' },
  },
  '&:hover': {
    background: '#01318D',
    transform: 'scale(1.09)',
    boxShadow: '0 8px 32px rgba(1,70,199,0.25)',
  },
}));

const Comparison: React.FC = () => {
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/AlphaPrep_SAT-ACT.pdf';
    link.download = 'AlphaPrep_SAT-ACT.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <ComparisonPaper>
      <Typography className='comparison_title'>SAT vs ACT — Which One's Right for You?</Typography>
      <Typography className='comparison_subtitle'>Skip the confusion. This visual guide breaks down everything — from question types to scoring systems</Typography>
      <img src={comparisonImg} alt='SAT vs ACT Comparison' className='comparison_image' />
      <AnimatedCTA onClick={handleDownload} className='comparison_cta'>
        Grab Your Free SAT vs ACT Comparison Guide.
      </AnimatedCTA>
    </ComparisonPaper>
  );
};

export default Comparison; 